import { render, staticRenderFns } from "./VirtualHall.vue?vue&type=template&id=f1408b54&scoped=true"
import script from "./VirtualHall.vue?vue&type=script&lang=js"
export * from "./VirtualHall.vue?vue&type=script&lang=js"
import style0 from "./VirtualHall.vue?vue&type=style&index=0&id=f1408b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1408b54",
  null
  
)

export default component.exports